import Flickity from 'flickity';
import ScrollReveal from 'scrollreveal';
import 'bootstrap';

function dewinze_InitHomepageSlider() {
	('use strict');

	const sliderElement = document.querySelector('.flickity-slider-element');

	if (!sliderElement) {
		return;
	}

	let flickityInstance = new Flickity(sliderElement, {
		accessibility: true,
		adaptiveHeight: true,
		autoPlay: 5000,
		cellAlign: 'center',
		cellSelector: undefined,
		contain: false,
		draggable: '>1',
		dragThreshold: 3,
		freeScroll: false,
		friction: 0.3,
		groupCells: false,
		initialIndex: 0,
		lazyLoad: true,
		percentPosition: true,
		prevNextButtons: true,
		pageDots: false,
		resize: false,
		rightToLeft: false,
		setGallerySize: true,
		watchCSS: false,
		wrapAround: true,
	});
}

window.addEventListener('load', dewinze_InitHomepageSlider, true);

function dewinze_InitScrollRevealItems() {
	('use strict');

	const revealImages = document.querySelectorAll('.wp-block-gallery .wp-block-image');
	let revealImagesDelay = 0;
	if (revealImages) {
		for (const revealImage of revealImages) {
			ScrollReveal().reveal(revealImage, {
				distance: '0px',
				opacity: 0,
				scale: 1,
				rotate: {
					x: 7,
					z: 7,
				},
				delay: revealImagesDelay,
			});
			revealImagesDelay += 100;
		}
	}

	const revealHomeIntroImage = document.querySelector('.homepage-intro__visual');
	const revealHomeIntroContent = document.querySelector('.homepage-intro__content');
	if (revealHomeIntroImage && revealHomeIntroContent) {
		ScrollReveal().reveal(revealHomeIntroImage, {
			opacity: 0,
			delay: 500,
			origin: 'bottom',
			distance: '50px',
		});

		ScrollReveal().reveal(revealHomeIntroContent, {
			opacity: 0,
			delay: 500,
			origin: 'top',
			distance: '50px',
		});
	}

	const revealCollageImages = document.querySelectorAll('.home-collage__visual');
	if (revealCollageImages) {
		for (const revealCollageImage of revealCollageImages) {
			ScrollReveal().reveal(revealCollageImage, {
				opacity: 0,
				scale: 0.75,
				delay: 0,
			});
		}
	}

	const revealHomeMenuImage = document.querySelector('.home-menu__visual');
	if (revealHomeMenuImage) {
		ScrollReveal().reveal(revealHomeMenuImage, {
			opacity: 0,
			delay: 0,
		});
	}

	const revealBlocks = document.querySelectorAll('.home-blocks .col-12');
	let revealOrigin = 0;
	if (revealBlocks) {
		for (const revealBlock of revealBlocks) {
			if (0 == revealOrigin) {
				revealOrigin = 1;
				ScrollReveal().reveal(revealBlock, {
					distance: '100px',
					opacity: 0,
					origin: 'left',
					delay: 200,
				});
			} else {
				revealOrigin = 0;
				ScrollReveal().reveal(revealBlock, {
					distance: '100px',
					opacity: 0,
					origin: 'right',
					delay: 200,
				});
			}

		}
	}

	const revealSlider = document.querySelector('.flickity-slider-element');
	if (revealSlider) {
		ScrollReveal().reveal(revealSlider, {
			opacity: 0,
			delay: 500,
		});
	}


}
window.addEventListener('load', dewinze_InitScrollRevealItems, true);

function dewinze_InitCanvasNav() {
	('use strict');

	const toggleButton = document.querySelector('.btn--menu');

	toggleButton.addEventListener(
		'click',
		(e) => {
			if (document.querySelector('body').classList.contains('canvas-visible')) {
				document
					.querySelector('body')
					.classList.remove('canvas-visible');
				toggleButton.classList.remove('is-active');
			} else {
				document
					.querySelector('body')
					.classList.add('canvas-visible');
				toggleButton.classList.add('is-active');
			}
		}
	);
}
window.addEventListener('load', dewinze_InitCanvasNav, true);

function dewinze_ToggleCanvasInit() {
	('use strict');

	const toggleButton = document.querySelector('.main-navigation button');
	toggleButton.addEventListener(
		'click',
		(e) => {
			document.querySelector('body').classList.toggle('canvas--visible');
		}
	);
}
window.addEventListener('load', dewinze_ToggleCanvasInit, true);

function dewinze_CalculateVH() {
	('use strict');

	// Set :root CSS variable to match window height.
	document.documentElement.style.setProperty(
		'--mobile-height',
		window.innerHeight + 'px'
	);

}
window.addEventListener('load', dewinze_CalculateVH, true);

function dewinze_TriggerScrolledClass() {
	('use strict');

	let deviceWidth = window.matchMedia('(max-width: 992px)');
	if (deviceWidth.matches) {

		if (0 < window.scrollY) {
			document.querySelector('body').classList.add('menubutton--fixed');
		} else {
			document.querySelector('body').classList.remove('menubutton--fixed');
		}
	}

}
window.addEventListener('scroll', dewinze_TriggerScrolledClass, true );
window.addEventListener('load', dewinze_TriggerScrolledClass, true);